import React from 'react';

export const EnvironmentBanner: React.FC = () => {
  const isStaging = process.env.REACT_APP_SENTRY_ENVIRONMENT === 'staging';
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (!isStaging && !isDevelopment) return null;

  const envName = isStaging ? 'STAGING' : 'DEVELOPMENT';
  const bgColor = isStaging ? 'bg-yellow-500' : 'bg-blue-500';

  return (
    <div
      className={`${bgColor} text-white text-center py-1 text-sm font-medium fixed top-0 left-0 right-0 z-50`}
    >
      {envName} ENVIRONMENT - Not for production use
    </div>
  );
};
